var map = {
	"./card.jpg": "9660",
	"./cards.jpg": "d8f5",
	"./contact-main.jpg": "843c",
	"./form2.jpg": "71eb",
	"./form3.jpg": "9216",
	"./hiromasa.jpg": "b26d",
	"./home-main.jpg": "f24e",
	"./icon-white.png": "65f4",
	"./login.jpg": "d164",
	"./macaron.png": "3dfe",
	"./single.png": "5584",
	"./single2.png": "cded",
	"./single3.jpg": "957f",
	"./store_logo.svg": "780d",
	"./博聖さまアイコン正面.jpg": "22b5",
	"./博聖様 (1)のコピー.psd": "3aba",
	"./博聖様アイコン横顔.jpg": "b27e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "17ac";